import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import Apple from '../../../common/components/svg/fruits/Apple';
import Blackberry from '../../../common/components/svg/fruits/Blackberry';
import Blueberry from '../../../common/components/svg/fruits/Blueberry3';
import Elderflower from '../../../common/components/svg/fruits/Elderflower';
import Mango from '../../../common/components/svg/fruits/Mango';
import Pear from '../../../common/components/svg/fruits/Pear';
import RedRhubarb from '../../../common/components/svg/fruits/RedRhubarb';
import Watermelon from '../../../common/components/svg/fruits/Watermelon';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  margin-top: 10rem;
  margin-bottom: 20rem;

  svg {
    margin: 0 2rem;
  }
`;

const Fruits = ({ loaded }: { loaded: boolean }) => {

  const refs = [
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
    useRef<SVGSVGElement>(null),
  ]

  const timelines = useAnimation(refs, loaded);

  const handleMouseOver = (i: number) => {
    if (!timelines.current[i].isActive()) {
      timelines.current[i].play(0);
    }
  }

  return (
    <Wrapper>
      <Apple ref={refs[0]} onMouseOver={() => handleMouseOver(0)} />
      <Blackberry ref={refs[1]} onMouseOver={() => handleMouseOver(1)} />
      <Blueberry ref={refs[2]} onMouseOver={() => handleMouseOver(2)} />
      <Elderflower ref={refs[3]} onMouseOver={() => handleMouseOver(3)} />
      <Mango ref={refs[4]} onMouseOver={() => handleMouseOver(4)} />
      <Pear ref={refs[5]} onMouseOver={() => handleMouseOver(5)} />
      <RedRhubarb ref={refs[6]} onMouseOver={() => handleMouseOver(6)} />
      <Watermelon ref={refs[7]} onMouseOver={() => handleMouseOver(7)} />
    </Wrapper>
  );
}

export default React.memo(Fruits);